export default __webpack_public_path__ + "static/media/3-1.72677a8d.png";